import { render } from "./template.vue?vue&type=template&id=4dbf104f&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=4dbf104f&scoped=true&lang=css"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbf104f"]])

export default __exports__